import {
  Controller,
  Control,
  FieldValues,
  DeepMap,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';

interface SelectMenu2Props {
  label: string;
  name: string;
  values: any[];
  valueAttr: string;
  labelAttr: string;
  control: Control<any>;
  required?: boolean;
  errors?: DeepMap<FieldValues, FieldError>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  defaultValue?: any;
  className?: string;
}

export default function SelectMenu2({
  label,
  name,
  control,
  values,
  valueAttr,
  labelAttr,
  required = false,
  errors,
  rules = undefined,
  defaultValue = undefined,
  className = undefined,
}: SelectMenu2Props) {
  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      render={({ field }) => (
        <FormControl className={className}>
          <TextField
            {...field}
            select
            required={required}
            label={label}
            variant="outlined"
            helperText={errors ? errors[name]?.message : undefined}
            error={errors ? !!errors[name] : false}>
            {values.map((val) => {
              return (
                <MenuItem value={val[valueAttr]} key={val[valueAttr]}>
                  {val[labelAttr]}
                </MenuItem>
              );
            })}
          </TextField>
        </FormControl>
      )}
    />
  );
}
